const libPictView = require('pict-view');
const libLayout = require('./PictView-Layout.js');

const _ViewConfiguration =
{
	ViewIdentifier: 'ToolDetail',
	DefaultRenderable: 'ToolDetail-Empty',
	CSS: /*css*/`
		.cst-td-input { background: var(--theme-color-text-primary, #1d2230); color: #d8dde8; padding: 10px 12px; border-radius: 4px; font-family: monospace; font-size: 11px; white-space: pre-wrap; max-height: 300px; overflow: auto; }
		.cst-td-output { background: var(--theme-color-text-primary, #1d2230); color: #d8dde8; padding: 10px 12px; border-radius: 4px; font-family: monospace; font-size: 11px; white-space: pre-wrap; max-height: 500px; overflow: auto; margin-top: 10px; }
		.cst-td-meta { font-size: 12px; color: var(--theme-color-text-secondary, #5b6376); margin: 10px 0; }
	`,
	Templates:
	[
		{ Hash: 'ToolDetail-Empty', Template: '<span></span>' }
	],
	Renderables: []
};

class PictViewToolDetail extends libPictView
{
	openTool(pToolUseId)
	{
		let tmpSession = this.pict.AppData.Session;
		if (!tmpSession) return;

		let tmpToolUse = null;
		let tmpToolResult = null;
		for (let i = 0; i < tmpSession.Turns.length; i++)
		{
			let tmpT = tmpSession.Turns[i];
			for (let j = 0; j < tmpT.Blocks.length; j++)
			{
				let tmpB = tmpT.Blocks[j];
				if (tmpB.Type === 'tool_use' && tmpB.ToolUseId === pToolUseId) tmpToolUse = tmpB;
				if (tmpB.Type === 'tool_result' && tmpB.ToolUseId === pToolUseId) tmpToolResult = tmpB;
			}
		}

		if (!tmpToolUse) return;

		let tmpHTML = '';
		tmpHTML += '<div class="cst-td-meta">Tool: <strong>' + libLayout.escapeHTML(tmpToolUse.Name) + '</strong></div>';
		if (tmpToolResult && tmpToolResult.DurationMs != null)
		{
			tmpHTML += '<div class="cst-td-meta">Duration: ' + libLayout.formatDuration(tmpToolResult.DurationMs) + '</div>';
		}
		if (tmpToolResult && tmpToolResult.IsError)
		{
			tmpHTML += '<div class="cst-td-meta" style="color:var(--theme-color-status-error, #c0353a);">Error</div>';
		}
		tmpHTML += '<div style="font-size:11px;color:var(--theme-color-text-secondary, #5b6376);margin-bottom:4px;">Input</div>';
		tmpHTML += '<div class="cst-td-input">' + libLayout.escapeHTML(JSON.stringify(tmpToolUse.Input || {}, null, 2)) + '</div>';
		if (tmpToolResult)
		{
			tmpHTML += '<div style="font-size:11px;color:var(--theme-color-text-secondary, #5b6376);margin-top:14px;margin-bottom:4px;">Output'
				+ (tmpToolResult.PersistedPath ? ' <em>(spilled to ' + libLayout.escapeHTML(tmpToolResult.PersistedPath) + ')</em>' : '')
				+ '</div>';
			tmpHTML += '<div class="cst-td-output">' + libLayout.escapeHTML(tmpToolResult.ContentText || '')
				+ (tmpToolResult.ContentTruncated ? '\n\n[truncated]' : '') + '</div>';
		}

		this.pict.views.Layout.openDetail(tmpToolUse.Name + ' details', tmpHTML);
	}
}

module.exports = PictViewToolDetail;
module.exports.default_configuration = _ViewConfiguration;
